import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Issue } from '~/api/seller-after-sales/types/requests.types'

export function useFormatIssues(issues: Array<Issue>) {
  const i18n = useI18n()

  const issuesLabels = issues.map((issue: Issue) =>
    issue.translationKey === null
      ? issue.type
      : i18n({ id: issue.translationKey, defaultMessage: '' }),
  )

  return issuesLabels.join(', ')
}
